const experience = [
  {
    id: 1,
    date: "Aug 2024 - Present",
    position: "Software Developer",
    company: "VITA",
    url: "https://www.vita.fo",
    description: [
      {
        id: 1,
        description: "PHP, React, JavaScript, TypeScript",
      },
    ],
  },
  {
    id: 2,
    date: "Nov 2023 - Present",
    position: "Software Developer",
    company: "atlanta.fo",
    url: "https://atlanta.fo",
    description: [
      {
        id: 1,
        description:
          "Work part-time in developing and maintain WordPress and WooCommerce website using custom themes.",
      },
      {
        id: 2,
        description:
          "Utilized PHP to customize Wordpress functionalities to create solutions.",
      },
      {
        id: 3,
        description:
          "Initiated an automation process for product importation, leveraging PHP scripting to streamline the process.",
      },
    ],
  },
  {
    id: 3,
    date: "Feb 2024 - July 2024",
    position: "Full stack Developer",
    company: "skaffa.fo",
    url: "https://skaffa.fo",
    description: [
      {
        id: 1,
        description:
          "Collaborated with a team of developers to optimize the company's software, reducing bugs and improving overall system performance.",
      },
      {
        id: 2,
        description:
          "Resolved a series of software bugs, improving system stability and user satisfaction.",
      },
      {
        id: 3,
        description:
          "Initiated and implemented an automated bug reporting process that integrates a webhook to notify the team via Discord.",
      },
    ],
  },
  {
    id: 4,
    date: "Feb 2023 - May 2023",
    position: "Software Developer Apprenticeship",
    company: "Afrikapu",
    url: "https://www.afrikapu.com",
    description: [
      {
        id: 1,
        description:
          "Received coaching and support from senior developers and gained practical experience in Android and Laravel for backend development",
      },
      {
        id: 3,
        description: "Created REST API’s and admin dashboard in Laravel.",
      },
      {
        id: 2,
        description:
          "Connected the admin dashboard and the application for seamless data exchange and synchronization.",
      },
    ],
  },
  {
    id: 5,
    date: "Sep 2022 - Dec 2022",
    position: "ICT Intern",
    company: "The Judiciary, Milimani Commercial courts",
    url: "#",
    description: [
      {
        id: 1,
        description:
          "Received coaching and support from senior specialits and gained practical experience in network infrastructure.",
      },
      {
        id: 2,
        description:
          "Installing and configuring hardware and software components, such as network infrastructure devices.",
      },
      {
        id: 3,
        description:
          "Developed a Laravel ticketing website to get client’s needs and admin to offer relevant feedback.",
      },
    ],
  },
  {
    id: 6,
    date: "Nov 2022 - Jan 2022",
    position: "Software Developer Intern",
    company: "Zalego Academy",
    url: "https://www.instagram.com/zalegoacademy/",
    description: [
      {
        id: 1,
        description:
          "Received coaching and support from senior developers and gained practical experience in Laravel for backend development.",
      },
      {
        id: 2,
        description:
          "Acquired proficiency in Laravel framework during the development process.",
      },
      {
        id: 3,
        description:
          "Enhanced web performance by using Model View Controller (MVC) architecture.",
      },
    ],
  },
];

export default experience;
